/** 회원가입 국적 드롭다운 — 전체 학교 검색용 (DB college_country_id와 겹치지 않도록 0 사용) */
export const SIGNUP_ALL_COUNTRY_ID = 0;

export const isSignupAllCountries = (countryId: unknown): boolean =>
  Number(countryId) === SIGNUP_ALL_COUNTRY_ID;

export const isSignupCountryChosen = (countryId: unknown): boolean =>
  countryId !== '' && countryId !== undefined && countryId !== null;

/** 전체 국적 선택 시 셀렉트박스에 충분한 학교 후보를 자동 노출하기 위한 요청 크기 */
export const SIGNUP_ALL_COLLEGE_SEARCH_SIZE = 5000;
